import { ServerResponse } from '../../../lib/classes/serverResponse';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../../jobs-module/models/listing.model';
import { CareerSubDomain } from '../../../lib/classes/careerSubDomain';

export class CareerListing extends ServerResponse {
  unit_id: number;
  career_page_subdomain?: CareerSubDomain;
  career_page_items?: JobListingItem[];
  publisher_is_draft?: boolean;
  publisher_is_published?: boolean;
  publisher_modified_at?: string;
  publisher_published_at?: number;
  created_at?: string;
  updated_at?: string;
  global_background_rgba?: string;
  global_text_style?: string;
  global_divider_status?: boolean;
  publisher_linked?: number;

  static createEmptyCareerListing(unit_id: number): CareerListing {
    return {
      unit_id: unit_id,
      global_background_rgba: '#FFFFFFFF',
      career_page_items: [
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_HEADER,
          position: 0,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_JOBS,
          position: 1,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER,
          position: 2,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
      ],
    };
  }
}
